import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Layout from "../components/Layout";
import { api } from "../lib/api";
import { ArrowLeft, Calendar } from "lucide-react";

export function NewsList() {
  const [news, setNews] = useState([]);
  useEffect(() => { api.get("/news").then((r) => setNews(r.data)); }, []);

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="mb-10">
          <span className="text-sm tracking-widest text-coastal uppercase">Stories</span>
          <h1 className="font-heading text-4xl lg:text-5xl text-navy tracking-tight mt-2" data-testid="news-title">From the coast</h1>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {news.map((n) => (
            <Link key={n.id} to={`/news/${n.slug || n.id}`} className="card-hover block rounded-2xl overflow-hidden bg-white border border-black/5" data-testid={`story-${n.slug || n.id}`}>
              <div className="aspect-[16/10] overflow-hidden bg-sand/30">
                {n.cover_image && <img src={n.cover_image} alt={n.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />}
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 text-xs text-coastal mb-2">
                  <Calendar className="w-3 h-3" />
                  {new Date(n.created_at).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}
                </div>
                <h3 className="font-heading text-xl text-navy mb-2">{n.title}</h3>
                <p className="text-sm text-neutral-500 line-clamp-3">{n.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  );
}

export function NewsDetail() {
  const { slug } = useParams();
  const [n, setN] = useState(null);
  useEffect(() => { api.get(`/news/${slug}`).then((r) => setN(r.data)); }, [slug]);
  if (!n) return <Layout><div className="py-20 text-center">Loading...</div></Layout>;

  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link to="/news" className="inline-flex items-center gap-2 text-navy/70 hover:text-navy mb-8" data-testid="back-to-news">
          <ArrowLeft className="w-4 h-4" /> All stories
        </Link>
        <div className="flex gap-2 mb-4 flex-wrap">
          {n.tags?.map((t) => <span key={t} className="text-xs tracking-widest uppercase text-coastal">{t}</span>)}
        </div>
        <h1 className="font-heading text-4xl lg:text-5xl text-navy tracking-tight mb-4" data-testid="news-detail-title">{n.title}</h1>
        <div className="text-sm text-neutral-500 mb-8">
          By {n.author_name} · {new Date(n.created_at).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" })}
        </div>
        {n.cover_image && (
          <div className="aspect-[16/9] rounded-2xl overflow-hidden mb-10">
            <img src={n.cover_image} alt={n.title} className="w-full h-full object-cover" />
          </div>
        )}
        <div className="prose max-w-none text-neutral-700 leading-relaxed text-lg whitespace-pre-line">
          {n.content}
        </div>
        {Array.isArray(n.images) && n.images.length > 0 && (
          <div className="grid sm:grid-cols-2 gap-6 mt-12" data-testid="news-gallery">
            {n.images.map((im, i) => (
              <figure key={im.url || `news-img-${i}`} className="rounded-2xl overflow-hidden bg-sand/30">
                <img src={im.url} alt={im.caption || ""} className="w-full h-auto object-cover" loading="lazy" />
                {im.caption && (
                  <figcaption className="px-5 py-3 text-sm text-neutral-600 italic border-t border-black/5">
                    {im.caption}
                  </figcaption>
                )}
              </figure>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
